import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LoginBox from 'js/reusable/auth/loginBox';
import {__} from 'js/tool/page/current';
import 'scss/components/no-certificate-fallback.scss';

function ServiceUnavailableFallback() {
	return (
		<LoginBox>
			<div className="no-cert-fallback">
				<div className="login-divider"/>

				<Row>
					<Col>
						<i className="fas fa-unlink fa-3x" />
					</Col>
				</Row>

				<Row>
					<Col>
						{__('fb:service unavailable')}
					</Col>
				</Row>
			</div>
		</LoginBox>
	);
}

export default ServiceUnavailableFallback;
